module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/pricing-slider-52bd2f6cba4bf03100c80a912e0248a9.png";